export default "__VITE_ASSET__CUgxb_wq__"